import React from "react";
import { Col, Row } from "react-bootstrap";
import { ActionHandlerFunction, DataExportRequest, UserIdentifierBase, UserProfile } from "@preveil-api";
import { AccountWSSteps, contentLabels, dayjs, UserRequest } from "src/common";
import { AwaitConnection, EstablishedConnection } from "../..";

type AllProps = {
  handleAction: ActionHandlerFunction;
  step?: number;
  data_export_request: UserRequest;
};

// Description: The Data Export process on the approvers side (settings) - where they approve the request through
// websocket communication
function DataExportStepComponent(props: AllProps) {
  const { handleAction, step, data_export_request } = props;
  const { parsed_payload, requester, expiration, timestamp: created_time, export_content, status } = data_export_request;
  const { from, until, users } = parsed_payload.data as DataExportRequest;
  const { name } = requester as UserProfile;
  const content_label = export_content && Object.keys(export_content).filter((key) => (export_content as any)[key]).map((key) => {
    const _key = key.split("include_")[1];
    return (contentLabels.content as any)[_key];
  }).filter((value) => !!value).join(" & ");
  const timeframe = `${dayjs(from).format("MM/DD/YYYY")} - ${dayjs(until).format("MM/DD/YYYY")}`;

  function displayDetails() {
    return <>
      <div className="readonly-details small">
        <p><span>Requester</span> {name}</p>
        <p><span>Status</span> {status}</p>
        <p><span>Content</span> {content_label}</p>
        <p><span>Timeframe</span> {timeframe}</p>
        <p><span>Created</span> {created_time}</p>
        <p><span>Expires</span> {expiration}</p>
      </div>
      <div className="approvers-panel mb-3">
        <Row className="header-row">
          <Col>{`Users: ${users.length}`}</Col>
        </Row>
        {
          !!users && users.map((user: UserIdentifierBase) => {
            return <Row key={user.user_id}>
              <Col md={10}>{user.user_id}</Col>
            </Row>;
          })
        }
      </div>
    </>;
}

  function renderStepUI(step?: number) {
    switch (step) {
      case AccountWSSteps.GET_CONNECTION_ESTABLISHED:
      case AccountWSSteps.ERROR:
        return <EstablishedConnection handleAction={handleAction} />;
      case AccountWSSteps.INITIALIZE_CONNECTION:
      case AccountWSSteps.GET_ACCEPTED_INIT_OK:
        return !!requester && <AwaitConnection requester={requester} handleAction={handleAction} />;
      default:
        return displayDetails();
    }
  }
  return <>{renderStepUI(step)}</>;
}

export default React.memo(DataExportStepComponent);